export const COLORS = {
  SURFACE_1: "#ff7a5b",
  SURFACE_2: "#f7f0e8",
  SURFACE_GRAY: "#f0f0f0",
};
